import { Button, Typography } from '@carto/meridian-ds/components'
import { Box } from '@mui/material'
import workspaceVectorUrl from 'assets/img/carto-logo-positive.svg'
import SnowflakeLogo from 'assets/icons/connectors/snowflake.svg?react'
import ErrorAlert from 'features/common/ui/ErrorAlert/ErrorAlert'
import { FormattedMessage } from 'react-intl'

function WelcomeMessage({ onContinue: handleClick, loading: isLoading, error }) {
  const isRejected = !!error
  const showSecondAttempt = isLoading || isRejected
  return (
    <Box textAlign="center">
      <img src={workspaceVectorUrl} height={32} />

      <Typography variant="h6" mb={1} mt={3}>
        {showSecondAttempt ? (
          <FormattedMessage id="snowflakeInApp.secondAttempt.title" />
        ) : (
          <FormattedMessage id="snowflakeInApp.welcome.title" />
        )}
      </Typography>
      <Typography color="textSecondary" mb={4} maxWidth={600} textAlign="center">
        {showSecondAttempt ? (
          <FormattedMessage id="snowflakeInApp.secondAttempt.description" />
        ) : (
          <FormattedMessage id="snowflakeInApp.welcome.description" />
        )}
      </Typography>
      {error && (
        <Box textAlign="left" mb={2}>
          <ErrorAlert error={error} />
        </Box>
      )}
      <Button
        variant="contained"
        size="large"
        loading={isLoading}
        onClick={handleClick}
        startIcon={!showSecondAttempt ? <SnowflakeLogo /> : undefined}
      >
        {!showSecondAttempt ? (
          <FormattedMessage id="snowflakeInApp.welcome.button" />
        ) : (
          <FormattedMessage id="snowflakeInApp.secondAttempt.button" />
        )}
      </Button>
      {!isLoading && (
        <Typography variant="body2" mt={3}>
          <FormattedMessage id="snowflakeInApp.documentationLink" />
        </Typography>
      )}
    </Box>
  )
}

export default WelcomeMessage
